import { render } from "./Cours.vue?vue&type=template&id=5745f044&ts=true"
import script from "./Cours.vue?vue&type=script&lang=ts"
export * from "./Cours.vue?vue&type=script&lang=ts"

import "./Cours.vue?vue&type=style&index=0&id=5745f044&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__